<template>
    <router-link to="/">
        <header id="header">
            <img src="../assets/logo-cogedim.png" class="logo"/>
            <div class="mask-shadow"></div>
            <img :src="require('../assets/' + banner)" class="header-banner cover-center" v-bind:class="{customPers: banner == 'pers-appartement.jpg' }"/>
        </header>
    </router-link>
</template>

<style lang="scss" scoped>
    #header {
        position: relative;
        /*
        height: 683px;
        @media (min-width: 992px) {
            height: 623px;
        }
        */
        height: 100vh;
    }
    
    
    
    .mask-shadow {
        position: absolute;
        bottom: 145px;
        left: 0;
        z-index: 2;
        min-height: 340px;
        height: calc(55%);
        width: 100%;
        object-fit: contain;
        background-image: -webkit-linear-gradient(rgba(66, 20, 95, 0), #42145f);
        background-image: -moz-linear-gradient(rgba(66, 20, 95, 0), #42145f);
        background-image: -o-linear-gradient(rgba(66, 20, 95, 0), #42145f);
        background-image: linear-gradient(rgba(66, 20, 95, 0), #42145f);
    } 
    
    .cover-center {
        position: absolute;
        top: 0;
        left: 0;
        z-index: 0;
        width: 100%;
        height: 100%;
        -o-object-fit: cover;
        object-fit: cover;
    
        -o-object-position: center;
        object-position: center;
        
        @media (min-width: 992px) { 
            -o-object-position: 0 -120px;
            object-position: 0 -120px;
        }
    }
    .customPers { 
        -o-object-position: -80px -100px !important;
        object-position: -80px -100px !important;
        @media (min-width: 992px) {
            -o-object-position: 0 0 !important;
            object-position: 0 0 !important;
            transform: scale(1.15) !important;
        }
    }
    img {
        display: block;
        z-index: 1;
        position: relative;
        &.logo { 
            z-index: 2;
            position: absolute;
            top: 30px;
            left: 30px;
        }
    }
</style>

<script>
// @ is an alias to /src
export default {
  name: 'HeaderGeneral',
  props: {
    banner: String
  },
  mounted ()  {
      
  }
}
</script>
